/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";

/** Common Components */
import MolGrid, { Column } from "@moltech/molui/molgrid";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CardSection from "../../../../../../components/ui/card/CardSection";
import CustomCenterModel from "../../../../../../components/ui/customCenterModel/CustomCenterModel";
import { AppIcons } from "../../../../../../data/appIcons";

/** Utilities */
import AddAffiliates from "./features/AddAffiliates";
import { useContractDepartmentInvoiceScheduleGetMutation, useDeleteContractAffiliateMutation, useGetAllContractScopesMutation, useGetContractAffiliatesListMutation, useLazyContractAffiliateInvoiceExistsQuery } from "../../../../../../app/services/contractAPI";
import ToastService from "../../../../../../services/toastService/ToastService";
import SwalAlert from "../../../../../../services/swalService/SwalService";
import { ContractContext } from "../../../../../../utils/context/ContractContext";


const Affiliates = () => {
  const { contractData ,contractId } = useContext(ContractContext);
  const gridRef = useRef();
  const [gridData, setGridData] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const { error, confirm } = SwalAlert();

  const [getContractAffiliatesList, {
    isLoading: isAffiliatesListLoding,
    isSuccess: isAffiliatesListFetching,
    data: affiliatesListData
  }] = useGetContractAffiliatesListMutation();

  const [deleteContractAffiliate, {
    isSuccess: isContractAffiliateDeleted,
    data: deleteContractAffiliateData
  }] = useDeleteContractAffiliateMutation();

  const [contractAffiliateInvoiceExists, {
    isSuccess: isContractAffiliateInvoiceExistsDeleted,
    data: contractAffiliateInvoiceExistsData
  }] = useLazyContractAffiliateInvoiceExistsQuery();

  const [contractDepartmentInvoiceScheduleGet, {
    isSuccess: isContractDepartmentInvoiceScheduleGetDeleted,
    data: contractDepartmentInvoiceScheduleGetData
  }] = useContractDepartmentInvoiceScheduleGetMutation();

  const [getAllContractScopes, {
    isFetching: isAllContractScopesFetching,
    isSuccess: isAllContractScopesFetched,
    data: AllContractScopesData,
  }] = useGetAllContractScopesMutation();

  useEffect(() => {
    getAffiliateList();
  }, [contractId])

  useEffect(() => {
    if (!isAffiliatesListLoding && isAffiliatesListFetching && affiliatesListData) {
      setGridData(affiliatesListData);
    }
  }, [isAffiliatesListLoding, isAffiliatesListFetching, affiliatesListData])

  useEffect(() => {
    if (isContractAffiliateDeleted && deleteContractAffiliateData) {
      if (deleteContractAffiliateData) {
        ToastService.success(deleteContractAffiliateData?.errorMessage);
        getAffiliateList();
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
  }, [isContractAffiliateDeleted, deleteContractAffiliateData, getContractAffiliatesList]);

  useEffect(() => {
    if (isContractAffiliateInvoiceExistsDeleted && contractAffiliateInvoiceExistsData) {
      if (contractAffiliateInvoiceExistsData) {
        ToastService.success(contractAffiliateInvoiceExistsData?.errorMessage);
        getAffiliateList();
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
  }, [isContractAffiliateInvoiceExistsDeleted, contractAffiliateInvoiceExistsData, getContractAffiliatesList]);

  useEffect(() => {
    if (isContractDepartmentInvoiceScheduleGetDeleted && contractDepartmentInvoiceScheduleGetData) {
      if (contractDepartmentInvoiceScheduleGetData) {
        ToastService.success(contractDepartmentInvoiceScheduleGetData?.errorMessage);
        getAffiliateList();
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
  }, [isContractDepartmentInvoiceScheduleGetDeleted, contractDepartmentInvoiceScheduleGetData, getContractAffiliatesList]);


  useEffect(() => {
    if (!isAllContractScopesFetching && isAllContractScopesFetched && AllContractScopesData) {
    }
  }, [isAllContractScopesFetching, isAllContractScopesFetched, AllContractScopesData])


  const getAffiliateList = () => {
    const req = {
      plAffiliateKey: null,
      plContractKey: contractId,
      pbCurrentOnly: false
    }
    getContractAffiliatesList(req);
  }

  const handleAddClick = () => {
    setIsModelOpen(true);
    setSelectedRow(null);
  };

  const handleCloseModel = () => {
    setIsModelOpen(false);
  };


  const handalRowEditClick = (rowData) => {
    setSelectedRow(rowData);
    setIsModelOpen(true);
  }

  const handleDelete = async (row) => {
     const plAffiliateKey = row?.lAffiliateKey;
      const exist = await contractAffiliateInvoiceExists(plAffiliateKey).unwrap();

      if (exist?.invoiceExists === true) {
        error("Invoice exists for this affiliate.", "Delete Not allowed");

        return;
      }
      const terminationDate = contractData?.dtDateTermination;
      const today = new Date();

      const dtAsOfDate =
        terminationDate === null
          ? today
          : new Date(terminationDate) > today
            ? today
            : new Date(terminationDate);

      const contractScopesreq = {
        plContractKey: contractId,
        pbIncludeInactive: true,
        pdtAsOfDate: dtAsOfDate,
        plScopeKey: 0,
        pbExcludeCPO: false,
        pbShowFutureScopes: true
      };

      const scopeData = await getAllContractScopes(contractScopesreq).unwrap();

      if (scopeData?.length > 0) {
        const confirmed = await confirm(
          "",
          "WARNING: There are scopes assigned to this contract that belong to this affiliate. If you remove this department, those scopes will also be removed. ARE YOU SURE YOU WANT TO CONTINUE?",
          "Yes",
          "No"
        );
        if (!confirmed) return;

        const scheduleReq = { plContractKey: contractId, plDepartmentKey: row.lDepartmentKey };
        const scheduleData = await contractDepartmentInvoiceScheduleGet(scheduleReq).unwrap();

        if (Array.isArray(scheduleData) && scheduleData.length > 0) {
          const confirmed = await confirm(
            "",
            "WARNING: This affiliate has an invoice schedule. If you remove it the schedule will be removed as well. ARE YOU SURE YOU WANT TO CONTINUE?",
            "Yes",
            "No"
          );
          if (!confirmed) return;
        }
      }
      const finalConfirm = await confirm(
        "",
        "Are you sure you want to remove this affiliate?",
        "Delete",
        "Cancel"
      );
      if (!finalConfirm) return;
      const req = plAffiliateKey;
      await deleteContractAffiliate(req).unwrap();
      ToastService.success(req.errorMessage);
  };


  const getCtxMenuItems = (row) => {
    if (!row) return [];
    return [
      {
        label: "Edit Affiliate",
        command: () => {
          handalRowEditClick(row);
        }
      },
      {
        label: "Delete Affiliate",
        command: () => {
          handleDelete(row);
        }
      }
    ];
  };
  const headerContent = () => {
    return (
      <div className="d-flex justify-content-end gap-3 export-icon">
        <Buttons
          buttonText="Add Affilliate"
          onClick={handleAddClick}
          buttonTypeClassName="btn blue-btn"
          titleText="Unassign Selected Items"
        />
      </div>
    );
  };
  return (
      <div className="row gap-4">
        <div className="scrollable-grid col-12">
          <CardSection
            cardTitle={`Affiliates`}
            customHeader={true}
            headerContent={headerContent()}
          >
            <MolGrid
              ref={gridRef}
              value={gridData}
              grouping
              expandableRowGroups={true}
              paginator={false}
              scrollable
              scrollHeight="flex"
              filterDisplay="row"
              sortMode="single"
              showGridlines
              resizableColumns
              ctxMenuItems={getCtxMenuItems}
            >
              <Column field="client" header="Client" grouping sortable />
              <Column
                field="department"
                header="Department"
                grouping
                sortable
                bodyStyle={{ textAlign: "Center" }}
              />

              <Column
                field="startDate"
                header="Effective Date"
                colType="datetime"
                format="mm/dd/yyyy"
                grouping
                sortable
                bodyStyle={{ textAlign: "Center" }}
              />
              <Column
                field="endDate"
                header="End Date"
                colType="datetime"
                format="mm/dd/yyyy"
                grouping
                sortable
                bodyStyle={{ textAlign: "Center" }}
              />
            </MolGrid>
          </CardSection>
          <CustomCenterModel
            isOpen={isModelOpen}
            useCustomBg={true}
            modalTitle={selectedRow ? "Edit Contract Affilliate" : "Add Contract Affilliate"}
            contentClass="content-50"
            onClose={handleCloseModel}
            modalTitleIcon={AppIcons.AddIcon}
            className="amendments-center-model"
          >
            <AddAffiliates isOpen={isModelOpen} contractId={contractId} rowData={selectedRow} onClose={handleCloseModel} getList={getAffiliateList} />
          </CustomCenterModel>
        </div>
      </div>
  );
};
export default Affiliates;
